import { InputLabel, Select, MenuItem, Grid } from '@mui/material';
import { style } from '../constant/constants';
import PropTypes from 'prop-types';

const CustomDropdown = ({
  value,
  onChange,
  list,
  name,
  label,
  isId,
  styles,
  isRequired,
  disabled = false,
  allowEmptySelection,
  sx,
  ...props
}) => {
  return (
    <Grid item xs={12} justifyContent="space-between" sx={[{ mt: '1vh', mx: '3vh' }, sx]}>
      <InputLabel
        htmlFor="demo-simple-select-label"
        sx={{
          fontFamily: style.fontFamily,
          color: style.LIGHT.primary
        }}>
        {label} {isRequired && <span className="text-red-600">*</span>}
      </InputLabel>

      <Select
        {...props}
        value={value || null}
        onChange={onChange}
        style={styles}
        name={name}
        size="small"
        disabled={disabled}>
        {allowEmptySelection && (
          <MenuItem value={undefined} key={'1111'}>
            {'None'}
          </MenuItem>
        )}

        {list?.length > 0 &&
          list.map(({ name, id }) => {
            return (
              <MenuItem value={isId ? id : name} key={id}>
                {name}
              </MenuItem>
            );
          })}
      </Select>
    </Grid>
  );
};

CustomDropdown.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  list: PropTypes.array,
  value: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  onFocus: PropTypes.func,
  required: PropTypes.bool,
  isId: PropTypes.bool, // to use id in place of name as value it should be set to true
  disabled: PropTypes.bool,
  styles: PropTypes.object,
  isRequired: PropTypes.bool,
  allowEmptySelection: PropTypes.bool,
  sx: PropTypes.object
};

export default CustomDropdown;
